import { useEffect, useCallback } from 'react';
import { negativeStatus } from 'interface/course';

import { sendElastic } from 'actionCreators/judasLog';
import { useAppSelector } from './redux';

export const useEmitCourseMessages = () => {
  const courseHash = useAppSelector((state) => state.course?.hash);
  const courseTitle = useAppSelector((state) => state.course?.title);
  const courseStatus = useAppSelector((state) => state.course?.status);

  const sendMessage = useCallback(() => {
    if (!courseHash) return;
    const message = negativeStatus.includes(courseStatus)
      ? `Visualizou o curso ${courseTitle} bloqueado(a)`
      : `Visualizou o curso ${courseTitle}`;
    sendElastic('viewCourse', message, {
      courseHash,
      status: courseStatus,
    });
  }, [courseHash, courseStatus, courseTitle]);

  useEffect(() => {
    sendMessage();
  }, [sendMessage]);
};
